module.exports = __webpack_public_path__ + "media/images/front/sp/article/doctor02-01c514dfdcb44aeef2edf95cffe21e64.png";